import React, { Component } from 'react';

import { History as history, Routes as routes } from '../navigation';
import { Header } from '../components';
import '../css/SignIn.css';

class PracticeFrontDeskAccounts extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderPracticeFrontDeskAccounts = (locations, accounts) => {

    if (locations.length === 0) {
      return null;
    }

    const locationRows = locations.map((location) => {
      const locationHasFrontDesk = this.doesFrontDeskExist(location);
      return <div className="flex-container flex-container-row flex-space-between" style={{ marginBottom: 15 }} key={location._id}>
        <div className="flex-container flex-container-column">
          <span style={{ fontSize: 13, color: 'grey' }}>{ location.name ? location.name : location.street_address }</span>
          <span style={{ color: 'grey', fontSize: 13, marginTop: -4 }}>{ locationHasFrontDesk ? 'Front Desk Account Added' : 'This location does not have a front desk account' }</span>
        </div>
        <div className="flex-container flex-container-column flex-center-justify">
        <input  type="submit"
                value={ locationHasFrontDesk ? 'Edit Account' : '+ Add Account' }
                className="button-clear-blue"
                style={{ fontSize: 13 }}
                onClick={ () => {
                  this.props.practiceActions.openPracticeFrontDeskEdit(location._id);
                }}
              />
        </div>
      </div>
    })

    return <div className="standard-container">
      <Header title='Front Desk/CSR Account(s)' icon='fas fa-concierge-bell' />

      <div className="flex-container flex-container-column" style={{ paddingLeft: 15, paddingRight: 15, paddingTop: 15 }}>
        { locationRows }
      </div>
    </div>
  }

  render() {
    if (this.props.hide) {
      return null;
    }
    return this.renderPracticeFrontDeskAccounts(this.props.locations, this.props.frontDeskAccounts);
  }

  doesFrontDeskExist = (location) => {
    var hasFrontDesk = false;
    var locationID = location._id || '';
    var fdUsers = this.props.frontDeskUsers || [];

    fdUsers.forEach((user) => {
      if (locationID && locationID === user.location_id) {
        hasFrontDesk = true;
      }
    })

    return hasFrontDesk;
  }

}


export default PracticeFrontDeskAccounts
